/** Explicitly authorized generated promotional art; native rewards remain separate pipeline icons. */
export const PROMO_ART_IDS = ["supply-drop", "mecha-vanguard", "event-frontier"] as const;
export type PromoArtId = (typeof PROMO_ART_IDS)[number];

export function promoUrl(id: PromoArtId): string {
  if (!PROMO_ART_IDS.includes(id)) throw new Error(`Unknown promotional artwork: ${String(id)}`);
  return `/assets/promos/${id}.png`;
}

export function PromoArt({ id, className = "" }: { id: PromoArtId; className?: string }) {
  return <img src={promoUrl(id)} width={1536} height={1024} alt="" className={`promo-art ${className}`} data-promo-art={id} decoding="async" draggable={false} />;
}
